import { Button, Col, Popconfirm, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import styled from 'styled-components';
import { ChangeOrder } from '../../modules/change-orders';
import { priceToString } from '../../util/utils';
import { styledTable } from '../styled/mixin';
import Title from 'antd/lib/typography/Title';

const StyledDiv = styled.div`
  ${styledTable}
`;

function PCCOListComponent({
  data,
  onDelete,
  moveToCreatePage,
  moveToDetailPage,
}: {
  data: ChangeOrder[];
  onDelete: (changeOrder: ChangeOrder) => void;
  moveToCreatePage: () => void;
  moveToDetailPage: (changeOrderId: number) => void;
}) {
  const columns: ColumnsType<ChangeOrder> = [
    {
      title: '제목',
      dataIndex: 'title',
      width: '50%',
      render: (text: any, record: any) => (
        <span
          className="clickable-table-item"
          onClick={() => moveToDetailPage(record.id)}
        >
          {text}
        </span>
      ),
    },
    // {
    //   title: '상태',
    //   dataIndex: 'status',
    //   render: (text: any, record: ChangeOrder) =>
    //     changeOrderStatusKorean[record.status],
    // },
    {
      title: '변경일',
      dataIndex: 'changeDate',
      width: '20%',
    },
    {
      title: '금액(공급가액)',
      dataIndex: ['priceData', 'priceData', 'supplyPrice'],
      width: '25%',
      align: 'right',
      render: (text: any, record: ChangeOrder) => priceToString(text),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              onConfirm={() => onDelete(record)}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={3}>설계변경</Title>
        </Col>
        <Col>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              moveToCreatePage();
            }}
            size="small"
          >
            등록
          </Button>
        </Col>
      </Row>

      {data && (
        <Table<ChangeOrder>
          rowKey="id"
          columns={columns}
          dataSource={data}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          summary={(pageData) => {
            let totalValue = 0;

            pageData.forEach(({ priceData }) => {
              totalValue += priceData.priceData.supplyPrice;
            });

            return (
              <>
                {
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}></Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="right">
                      Total:
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2} align="right">
                      {priceToString(totalValue)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                  </Table.Summary.Row>
                }
              </>
            );
          }}
        />
      )}
    </StyledDiv>
  );
}

export default PCCOListComponent;
